/* **************************** */
/*       String replaceAll      */
/* **************************** */

if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (str, newStr) {
    // If a regex pattern
    if (
      Object.prototype.toString.call(str).toLowerCase() === '[object regexp]'
    ) {
      return this.replace(str, newStr);
    }

    // If a string
    return this.split(str).join(newStr);
  };
}

/* **************************** */
/*       Promise.any            */
/* **************************** */

if (!Promise.any) {
  Promise.any = (promises) =>
    new Promise((resolve, reject) => {
      let hasResolved = false;
      let promiseLikes = [];
      let iterableCount = 0;
      let rejectionReasons = [];

      function resolveOnce(value) {
        if (!hasResolved) {
          hasResolved = true;
          resolve(value);
        }
      }

      function rejectionCheck(reason) {
        rejectionReasons.push(reason);

        if (rejectionReasons.length >= iterableCount) {
          reject(rejectionReasons);
        }
      }

      for (let prom of promises) {
        iterableCount++;
        promiseLikes.push(prom);
      }

      for (let promiseLike of promiseLikes) {
        if (
          promiseLike?.then !== undefined ||
          promiseLike?.catch !== undefined ||
          promiseLike?.finally !== undefined
        ) {
          promiseLike
            ?.then((result) => resolveOnce(result))
            ?.catch(() => undefined);

          promiseLike?.catch((reason) => rejectionCheck(reason));
        } else {
          resolveOnce(promiseLike);
        }
      }
    });
}

/* **************************** */
/*    Promise.withResolvers     */
/* **************************** */

// Required by pdfjs-dist v5 (react-pdf) core + worker; native only in
// Safari 17.4+, Chrome 119+, Firefox 121+. Without it the in-app PDF report
// viewer/printer throws "undefined is not a function" on older Safari.
if (!Promise.withResolvers) {
  Promise.withResolvers = function withResolvers() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

/* **************************** */
/*          URL.parse           */
/* **************************** */

// Also required by pdfjs-dist v5 (react-pdf) — `getUrlProp` / `_isSameOrigin`.
// Native only in Safari 18.4+, Chrome 126+, Firefox 126+. It is the
// non-throwing variant of `new URL()`: returns a URL object, or null on
// failure instead of throwing.
if (!URL.parse) {
  URL.parse = function parse(url, base) {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}
